module.exports = __webpack_public_path__ + "static/media/burger-soda.c4ed6cb7.svg";